await import('/home/ubuntu/ky-so/sign-service-fe/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/home/ubuntu/ky-so/sign-service-fe/src/.umi/umi.ts');
export default 1;